import LegalContent from "@components/LegalContent"
import { withFinePrint } from "@utils/ContentfulRichText"
import { emptyRichText } from "@utils/richText"
import { renderRichText } from "gatsby-source-contentful/rich-text"
import React from "react"

import { ContentfulContentBaseProps } from "../types"

interface ContentfulLegalContentProps extends ContentfulContentBaseProps {}

const ContentfulLegalContent: React.FC<ContentfulLegalContentProps> = ({
  blockId,
  content,
}) => {
  return (
    <LegalContent
      blockId={blockId}
      content={renderRichText(content || emptyRichText, withFinePrint)}
    />
  )
}

export default ContentfulLegalContent
